import { deepTransformDate, deepTransformTimestamp } from '../../utils/date';
import { UserId, Uuid } from '../Base';
import { RepositoryElement } from '../Repository';

type RevisionRecord<T> = {
  endedAt: T;
  stars: number;
  nextPhase: number;
};

type MemorizePoint<T> = {
  memorizedAt: T;
  strength: number;
  percentage: number;
  isEstimated?: boolean;
};

export interface RevisionScheduleJson<T = number> {
  readonly gameId: string;
  userId: UserId;
  classroomId: Uuid;
  gameSetId: Uuid;
  gameCollectionId: Uuid;
  gameHash: string;
  createdAt: T;
  lastModifiedAt: T;
  willReviseAt: T;
  completedAt: T;
  records: RevisionRecord<T>[];
  forgettingCurve?: MemorizePoint<T>[];
}

export class RevisionSchedule
  extends RepositoryElement
  implements RevisionScheduleJson<Date>
{
  readonly gameId!: string; // identifier,
  userId!: UserId;
  classroomId!: Uuid;
  gameSetId!: Uuid;
  gameCollectionId!: Uuid;
  gameHash!: string;
  createdAt!: Date;
  lastModifiedAt!: Date;
  willReviseAt!: Date;
  completedAt!: Date;
  records!: RevisionRecord<Date>[];
  forgettingCurve!: MemorizePoint<Date>[];

  constructor(revisionSchedule: RevisionScheduleJson<Date | number>) {
    super();
    Object.assign(this, deepTransformTimestamp(revisionSchedule));
  }

  id(): string {
    return `${this.gameId}_${this.userId}_${this.classroomId}`;
  }

  toJSON(): RevisionScheduleJson {
    return deepTransformDate(this) as unknown as RevisionScheduleJson;
  }
}
